
import React from 'react'
import { FiChevronDown } from 'react-icons/fi' 
import {generateUser, getRandomInt} from '../../@shared/utils'
import {Paginate} from './paginate'
export const CategoryGridView = () =>{
    return (
        <section className='grid'>
            <div className='gridview'>
                <div className="flex heading">
                    <div className='result'>575 job found</div>
                    <div className="sort flex-start">
                        Sort: <div className='button'>
                            <p>Recommended</p> <FiChevronDown/>
                        </div>
                    </div>
                </div>
                <ul className='box'>
                {Array.from(Array(55)).map((item,i)=>{

                    return (
                        <li>
                            <a href="##">
                                <div
                                    className='bg'
                                    style={{
                                        background:`url(/assets/images/dummy/${ i }.png)`,
                                        backgroundSize:'contain',
                                    }}
                                />
                            </a>
                            <div className="detail">
                                <div>
                                    <div className="flex">
                                        <div className="flex cursor">
                                            <div>
                                                <img src={`/assets/images/faces/${  getRandomInt(1,23) }.png`} className='avatar' alt="" />
                                            </div>
                                            <div>
                                                <div className="name">{generateUser().name}</div>
                                                <div className="position">{generateUser().job}</div>
                                            </div>
                                        </div>
                                        <div className="price">
                                            <h3>500₺</h3>
                                            <small>Beginning</small>
                                        </div>
                                    </div>

                                </div>
                                <p className='description'> Ipsum dolorem id sapiente, minima officiis dolor qui. </p>
                            </div>
                        </li>
                    )
                })}
                </ul>
            </div>
            <Paginate />
        </section>
    )
}
